import React from 'react';
import { connect } from 'react-redux';
import api from '../../../utils/api';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import { push } from 'connected-react-router';
import { TextField } from "redux-form-material-ui";

class AddBranchView extends React.Component {
    onSubmit = values => {};

    constructor(props) {
        super(props);
    }

    componentDidMount = () => {};

    handleClose = () => {
        this.props.dispatch(push('/branches'));
    };

    render = () => {
        const actions = [
            <FlatButton label="Abbrechen" primary={true} onClick={this.handleClose} />,
            <FlatButton
                label="Filiale hinzufügen"
                primary={true}
                keyboardFocused={true}
                onClick={() => {
                    this.props.addBranch({branch_id: this.branchId.refs.component.input.value})
                }}
            />,
        ];

        return (
            <div>
                <Dialog
                    title="Neue Filiale hinzufügen"
                    modal={false}
                    actions={actions}
                    open={true}
                    onRequestClose={this.handleClose}>
                    <form>
                        <TextField name="branch_id" ref={e => this.branchId = e} type="number" label="Filial-Nr." />
                    </form>
                </Dialog>
            </div>
        );
    };
}

const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = dispatch => ({
    dispatch,
    addBranch: payload => dispatch(api.actions.branches.addBranch(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddBranchView);
